import apiFleetManager from "@Config/api/clientFleetManager";

export interface MyClient {
  customerId: number;
  name: string;
  cpfCnpj: string;
  fuelControl: boolean | null;
  useRequisition: boolean;
  registrationDate: string;
}

export interface MyClientsResponse {
  previousPage: number | null;
  nextPage: number | null;
  currentPage: number;
  isLast: boolean;
  totalPages: number;
  totalItens: number;
  totalItemsPage: number;
  maxItemsPerPage: number;
  paged: boolean;
  data: MyClient[];
}

/**
 * Lista apenas os clientes associados ao usuário autenticado.
 * Esta é a base do controle "usuário comercial só vê as próprias empresas".
 */
export const myClientsApi = {
  getMyClients: (
    page: number = 1,
    pageSize: number = 10,
    name?: string
  ): Promise<MyClientsResponse> => {
    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
    });

    if (name) {
      params.append("SearchFilter", name);
    }

    return apiFleetManager
      .get(`api/users/customers?${params.toString()}`)
      .then((res) => res.data);
  },
};
